import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  AuctionObject, BidAction, BidNegotiation, ClosedAuctionDetails
} from 'appRootPath/models/commercial-papers.model';

const closeAuctionAction = 'close_auction';
const getIssueFromAuction = 'get_auction_for_issue_details';

@Injectable({
  providedIn: 'root'
})
export class CpAuctionApiService {
  private apiPath = environment.serverUrl;

  private endpoints = {
    auction: '/auction/auction/',
    bid_thread: '/auction/bidthread/',
    bid: '/auction/bid/',

  };

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Gets list of all auction objects created for the current session.
   * @return - Observable of List of all auctions.
   */
  getAuctions(): Observable<AuctionObject[]> {
    return this.http.get<AuctionObject[]>(`${this.apiPath}${this.endpoints.auction}`);
  }

  /**
   * Gets auction objects with given Id created for the current session.
   * @return - Observable of List of all auctions.
   */
  getAuctionById(auctionId): Observable<AuctionObject> {
    return this.http.get<AuctionObject>(`${this.apiPath}${this.endpoints.auction}${auctionId}/`);
  }

  /**
   * Gets list of all auctions with filter on the has_bids.
   * @param hasBids - Has investor placed bids.
   */
  getAuctionsWithBidsFilter(hasBids: boolean): Observable<AuctionObject[] | any[]> {
    return this.http.get<AuctionObject[]>(`${this.apiPath}${this.endpoints.auction}?has_bid=${hasBids ? 'True' : 'False'}`);
  }


  /**
   * get details for closed auction
   */
  getIssueDetailsForAuction(auctionId): Observable<ClosedAuctionDetails> {
    return this.http.get<ClosedAuctionDetails>(
      `${this.apiPath}${this.endpoints.auction}${auctionId}/${getIssueFromAuction}/`
    );
  }

  /**
   * API call to create auction.
   */
  createAuction(auctionData: AuctionObject): Observable<AuctionObject> {
    return this.http.post<AuctionObject>(`${this.apiPath}${this.endpoints.auction}`, auctionData);
  }

  /**
   * Submit a bid
   */
  submitBid(bidData) {
    return this.http.post(`${this.apiPath}${this.endpoints.bid}`, bidData);
  }

  /**
   * Create bid thread
   */
  createBidThread(bidThreadData) {
    return this.http.post(`${this.apiPath}${this.endpoints.bid_thread}`, bidThreadData);
  }

  /**
   * Handles accept or reject of the given bid.
   * @param bidId - ID of the bid.
   * @param isAccept - States whether the action is accept or reject.
   * @param stateValue - State Value of the action.
   */
  acceptOrRejectBid(bidId: string, isAccept: boolean, stateValue: string): Observable<BidNegotiation> {
    return this.http.post<BidNegotiation>(
      `${this.apiPath}${this.endpoints.bid}${bidId}/${isAccept ? 'accept_bid' : 'reject_bid'}/`,
      { state_value: stateValue }
    );
  }

  /**
   * Handles API call to ignore an auction by the investor.
   * @param auctionId - ID of the auction.
   */
  ignoreAuction(auctionId: string): Observable<string[]> {
    return this.http
      .post<string[]>(`${this.apiPath}${this.endpoints.auction}${auctionId}/ignore_auction/`, {});
  }

  /**
   * Close auction API call.
   */
  closeAuction(auctionId) {
    return this.http
      .post(`${this.apiPath}${this.endpoints.auction}${auctionId}/${closeAuctionAction}/`, null);
  }

}
